import { ButtonPrimary } from "components/Atoms/Button";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";

interface Props {
  article: server.dto.Article;
  onUpdated: () => void;
}

const BlogHeader = (props: Props) => {
  const [color, setColor] = React.useState(props.article.headerBackgroundHexColor);

  const imageRef = React.useRef<HTMLInputElement>(null);

  const onImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    const res = await uploadFileToCoreApi(
      window.CoreApi.Article.UploadArticleImage,
      window.CoreApi.Article.UploadArticleImage.absoluteUrl(),
      { file },
      { fileType: "image" }
    );
    if (res.data.hasErrors) {
      alert("Could not upload image");
      return;
    }

    await window.CoreApi.Article.SetHeaderImage(props.article.articleId, res.data.data.fileId);

    props.onUpdated();
  }

  const onSave = async () => {
    const isValid = color.trim() === "" || /^#[0-9A-F]{6}$/i.test(color);
    if (!isValid) {
      alert("Invalid color. Must be formatted like: #AABBCC");
      return;
    }

    await window.CoreApi.Article.SetHeaderBackgroundHexColor(props.article.articleId, color)
  }

  return <section className="flex gap justify-center align-center" style={{ backgroundColor: color, height: 210 }}>
    <input
      type="file"
      ref={imageRef}
      style={{ display: "none" }}
      accept="image/*"
      onChange={onImageChange} />

    <div>
      <div onClick={() => { imageRef.current.click() }}>
        {
          props.article.headerImage ?
            <img src={props.article.headerImage} className="listimage" /> :
            <div className="noheaderimage flex align-center justify-center">No image</div>
        }
      </div>
    </div>
    <div className="flex align-center" style={{ width: 300 }}>

      <div style={{ marginRight: 20 }}>
        <OptionalTextInput
          value={color}
          onChange={setColor}
          width={100}
          maxLength={7}
        />
      </div>

      <ButtonPrimary label={RESX.Buttons.btnSave} onClick={onSave} />
    </div>
  </section>
}

export default BlogHeader;